import React, {useEffect, useState, Fragment} from 'react';

import ModalContentWrapper from '../ModalContentWrapper';
import {getChildDetails, getChildImageUrl, updateChildDetails} from "../../DataFunctions/ChildDataFns";
import {saveNewUser} from "root/DataFunctions/UserDataFns";
import {getDataFromResponse, getNamedCustomDataFromResponse} from "../../DataFunctions/BaseDataFns";
import DemoModal from "root/DemoModal";
import {useForm} from "react-hook-form";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import DropdownCareStatus from "root/ReactHookForm/ui/DropdownCareStatus";
import DropdownOrgTeams from "root/ReactHookForm/ui/DropdownOrgTeams";
import DropdownResponsibleAdult from "root/ReactHookForm/ui/DropdownResponsibleAdult";
import SpinnerDiv from "root/Components/SpinnerDiv";
// import bootbox from "bootbox";
import PropTypes from "prop-types";
import phpVars from 'phpVars';
import {UserGroupTypes} from "root/DataFunctions/Constants";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";

const Title = ({mode}) =>
{
    const titles = {
        view: 'View Child Details',
        edit: 'Edit Child Details',
        create: 'New Child',
        delete: 'Delete Child'
    } ;

    return <h3>{titles[mode]}</h3>
}

const ModalUpdateChild = (props) =>
{
    const [ buttonState, setButtonState ] = useState ('') ;
    const [data, setData] = useState({ isLoading: true, data: [] });
    const [newImageData, setNewImageData] = useState( null );
    const [imageDataAlias, setImageDataAlias] = useState( null );
    const isFetchRequired = props.mode === 'edit' || props.mode === 'view' || props.mode === 'delete' ;
    const logged_in_user = phpVars.unenc_user_id;

    const submitButtonText = () => {
        switch (props.mode){
            case 'view':
                return 'Close';

            case 'edit':
                return 'Submit';

            case 'create':
                return 'Submit';

            case 'delete':
                return 'Delete';
        }
    } ;

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                user: {
                    user_id: { value : 0 } , /* This field uses raw dropdown-select objects */
                    firstname: '',
                    surname: '',
                    adopted_firstname: '',
                    adopted_surname: '',
                    dob: '',
                    description: '',
                    username: '',
                    userTypeId: undefined,
                    us_description: '',
                    status: 0,
                    email: '',
                    telno: '',
                    address1: '',
                    address2: '',
                    address3: '',
                    postcode: '',
                    unique_user_reference: null,
                    responsible_user_id: {value: logged_in_user, user_id: 0},
                    use_teen_interface: false
                }
            }
        });

    useEffect(() =>
    {
        if ( props.child_id !== null )
        {
            getUser();
        }
        else
        {
            if ( props.mode === 'create')
            {
                setData({ isLoading: false});
            }
        }

    }, []);

    const getUser = () =>{
        if ( isFetchRequired )
        {
            getChildDetails(props.child_id, (response) =>
            {
                let userData = getDataFromResponse(response)[0];
                const use_teen_interface = +userData.use_teen_interface === 0 ? false :true;

                setValue ( 'user',
                    {
                        user_id: { value: userData.idusers},
                        firstname: userData.firstname,
                        surname: userData.surname,
                        adopted_firstname: userData.adopted_firstname,
                        adopted_surname: userData.adopted_surname,
                        dob: userData.dob,
                        acs_id: { value: +(userData.care_status)},
                        description: userData.description,
                        username: userData.username,
                        userTypeId: { value: +(userData.userTypeId) },
                        us_description: userData.us_description,
                        team_id: { value: +(userData.team_id) },
                        email: userData.email,
                        telno: userData.telno,
                        address1: userData.address1,
                        address2: userData.address2,
                        address3: userData.address3,
                        postcode: userData.postcode,
                        unique_user_reference: userData.unique_user_reference,
                        use_teen_interface: use_teen_interface
                    }) ;
                setData({isLoading: false, data: userData});
                setImageDataAlias(userData.document_id);
            });
        }
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const doCreateUser = ( formData ) =>
    {
        saveNewUser(formData, (response) =>
        {
            const custom = getNamedCustomDataFromResponse( response, 'already_exists') ;
            const emailError = getNamedCustomDataFromResponse( response, 'email_error') ;

            if ( custom == true )
            {
                bootbox.alert({
                    size: "small",
                    message: 'You entered a unique reference number ' + formData['unique_user_reference'] + ' that is already assigned to another arcbox user in your organisation.\n\nPlease update and re-submit.',
                    callback: (result =>
                    {
                        //
                    })
                })
            }
            else if ( emailError == true )
            {
                const errorMessage = response.custom_data['error_message'];

                bootbox.alert({
                    size: "small",
                    message: errorMessage,
                    callback: (result =>
                    {
                        props.onSaveCompleted('saved');
                        props.onClose();
                    })
                })
            }
            else
            {
                bootbox.alert({
                    size: "small",
                    message: 'New User Created - an email has been sent to the user to register for ARCBOX',
                    callback: (result =>
                    {
                        props.onSaveCompleted('saved');
                        props.onClose();
                    })
                })
            }

        });
    }

    const doUpdateUser = ( formData ) =>
    {
        updateChildDetails(props.child_id, formData, (response) =>
        {
            const custom = getNamedCustomDataFromResponse( response, 'already_exists') ;

            if ( custom == true )
            {
                bootbox.alert({
                    size: "small",
                    message: 'You entered a unique reference number ' + formData.user['unique_user_reference'] + ' that is already assigned to another arcbox user in your organisation.\n\nPlease update and re-submit.',
                    callback: (result =>
                    {
                        //
                    })
                })
            }
            else
            {
                const message = 'User has been Updated';

                bootbox.alert({
                    size: "large",
                    title: 'Success ',
                    message: message,
                    callback: (result =>
                    {
                        props.onSaveCompleted('saved');
                        props.onClose();
                    })
                })
            }
        });
    }

    const doDelete = ( callback ) =>
    {
        deleteUser (props.child_id, (response) =>
        {
            props.onSaveCompleted ('saved');
            props.onClose() ;
        });
    }

    const getSubmitButtonText = ( mode ) =>
    {
        return submitButtonText() ;
    }

    const getSubmitButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const submitButton = (mode, onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSubmitButtonStyle(mode)}>{getSubmitButtonText(mode)}<i className="et-save" /></button>
        )
    }

    const onSubmit = (data, status) => {

        switch (props.mode)
        {
            case 'create' :
                data.user['image'] = newImageData;

                doCreateUser(data.user);
                break;

            case 'edit' :
                if (newImageData !== null) data.user['image'] = newImageData;

                doUpdateUser(data);
                break;

            case 'delete' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to archive this User?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doDelete();
                        }
                    })
                })
                break;
        }
    }

    const onClickSaveButton = (status) => {
        handleSubmit(onSubmit)(status);
    }

    const onImageChange = ( imageUrl ) =>
    {
        const reader = new window.FileReader();
        reader.readAsDataURL(imageUrl);

        reader.onloadend = () =>
        {
            setNewImageData ( reader.result ) ;
            setImageDataAlias ( reader.result ) ;
        }
    }

    const handleRemoveImage = () => {
        setNewImageData("");
        setImageDataAlias(null);
    }

    const isViewOnly = props.mode === 'view';
    const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;

    const validateDropdown = (val) =>
    {
        if ( val.value === undefined )
        {
            return "You must select a value." ;
        }
    }

    const renderHookForm = ( prop )  =>
    {
        const readOnlyMode = props.mode === 'view' || props.mode === 'delete' ? 'readonly' : '' ;
        const image_id = props.mode === 'create' ? null : data.data.document_id

        //We need to make certain fields read only based on the logged in user type group Ie. If we are not staff group (1) can't update these fields)
        let userTypeBasedReadOnly = true;

        //If not already readOnly
        if(!isReadOnly){
            userTypeBasedReadOnly = phpVars.user_type_group !== UserGroupTypes.USER_GROUP_STAFF;
        }

        return (
            <Fragment>
                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                    <div className="profile-img-container-wrap profile-img-container-wrap_child">
                        {!isReadOnly && 
                        <div className="post-all-image-wrap">
                            <div
                                className={imageDataAlias === null ?
                                            "post-all-image"
                                            :
                                            "post-all-image post-all-image_show"
                                        }
                            > 
                                <DemoModal 
                                    image_id={image_id} 
                                    provider_id={1} 
                                    dimensions={150} 
                                    onImageChange={onImageChange}
                                    newImageData={newImageData}
                                    imageDataAlias={imageDataAlias}
                                    data={data}
                                />
                                <span onClick={handleRemoveImage} className="post-image-remove">
                                    <i className='icon-close'/>
                                </span>
                                <div className="post-all-image-overlay post-all-image-overlay_single"></div>
                            </div>
                        </div>
                        }
                        {isReadOnly && <img src={getChildImageUrl(data.data.document_id, data.data.user_id)} style={{width: '150px'}} />}
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Firstname</label>
                                <input readOnly={userTypeBasedReadOnly} className='form-control' name='user.firstname' id='firstname' {...register("user.firstname",{ required: true})} />
                                { formErrors.user?.firstname && <ErrorDiv>Please enter a firstname</ErrorDiv> }
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Surname</label>
                                <input readOnly={userTypeBasedReadOnly} className='form-control' name='user.surname' id='surname' {...register("user.surname", { required: true})} />
                                { formErrors.user?.surname && <ErrorDiv>Please enter a surname</ErrorDiv> }
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Adopted Firstname</label>
                                <input readOnly={userTypeBasedReadOnly} className='form-control' name='user.adopted_firstname' id='adopted_firstname' {...register("user.adopted_firstname")} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Adopted Surname</label>
                                <input readOnly={userTypeBasedReadOnly} className='form-control' name='user.adopted_surname' id='adopted_surname' {...register("user.adopted_surname")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Preferred Name</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.description' id='description' {...register("user.description")} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>DOB</label>
                                <input readOnly={userTypeBasedReadOnly} className='form-control' name='user.dob' id='dob' {...register("user.dob")} />
                            </div>
                        </div>

                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Unique Reference Number</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.unique_user_reference' id='unique_user_reference' {...register("user.unique_user_reference")} />
                            </div>
                        </div>

                        {props.mode === 'create' &&<div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Team</label>
                                <DropdownOrgTeams readOnly={false}
                                                  control={control}
                                                  mode={props.mode}
                                                  name='user.team_id'
                                                  rules={{required: true, validate: validateDropdown}}
                                                  placeholder='Please select a user team'
                                                  isSearchable={true}
                                                  isClearable={true}
                                                  organisation={'current'}/>
                                {formErrors.user?.team_id &&
                                    <ErrorDiv>{formErrors.user.team_id.message}</ErrorDiv>}
                            </div>
                        </div>}
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Care Status</label>
                                <DropdownCareStatus readOnly={userTypeBasedReadOnly}
                                                    control={control}
                                                    mode={props.mode}
                                                    name='user.acs_id'
                                                    rules={{required: true, validate: validateDropdown}}
                                                    placeholder='Please select a care status'
                                                    isSearchable={true}
                                                    isClearable={true}/>
                                {formErrors.user?.acs_id &&
                                    <ErrorDiv>{formErrors.user.acs_id.message}</ErrorDiv>}
                            </div>
                        </div>

                        {props.mode === 'create' &&<div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Responsible Adult</label>
                                <DropdownResponsibleAdult readOnly={false}
                                                  control={control}
                                                  mode={props.mode}
                                                  name='user.responsible_user_id'
                                                  rules={{required: true, validate: validateDropdown}}
                                                  placeholder='Please select a user to register the child'
                                                  isSearchable={true}
                                                  isClearable={true}/>
                                {formErrors.user?.team_id &&
                                    <ErrorDiv>{formErrors.user.responsible_user_id.message}</ErrorDiv>}
                            </div>
                        </div>}
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div>
                                <label>Adult Login</label>
                                <div style={{marginTop: '5px'}}>
                                    <FormToggle readOnly={false} control={control} name='user.use_teen_interface'/>
                                    {formErrors.user?.use_teen_interface &&
                                        <ErrorDiv>{formErrors.user.use_teen_interface.message}</ErrorDiv>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        { props.mode !== 'create' && <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Username</label>
                                <input readOnly='readonly' className='form-control' name='user.username' id='username' {...register("user.username")} />
                            </div>
                        </div>}

                        { props.mode !== 'create' && <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>ARCBOX Status</label>
                                <input readOnly='readonly' className='form-control' name='user.us_description' id='us_description' {...register("user.us_description")} />
                            </div>
                        </div>}
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Email</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.email' id='email' {...register("user.email", { required: false})} />
                                { formErrors.user?.email && <ErrorDiv>Please enter a valid email</ErrorDiv> }
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Telephone</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.telno' id='telno' {...register("user.telno")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Address Line 1</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.address1' id='address1' {...register("user.address1")} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Address Line 2</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.address2' id='address2' {...register("user.address2")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Address Line 3</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.address3' id='address3' {...register("user.address3")} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Post Code</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.postcode' id='postcode' {...register("user.postcode")} />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left" /></button>
                        {!isViewOnly && submitButton(props.mode, onClickSaveButton)}
                    </div>
                </form>
            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} />
            <div style={{width: props.width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && renderHookForm ()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalUpdateChild;

ModalUpdateChild.defaultProps = {
        width: '600px'
}

ModalUpdateChild.propTypes = {
    child_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};